<template>
  <div>
    <lv-radio-group :style="groupStyle" :options="options" :optionLabel="optionLabelKey" :optionValue="optionValueKey" :pulse="pulse" color="success" outline :value="modelValue" @input="updateValue" />
  </div>
</template>

<script>
import LvRadioGroup from 'lightvue/radio-group';
import { trueValueMixin } from 'lightvue/mixins';
import selectPropsMixin from './selectPropsMixin';

export default {
  mixins: [trueValueMixin, selectPropsMixin],

  components: {
    LvRadioGroup,
  },
  props: ['options', 'color', 'pulse', 'options_layout'],
  computed: {
    groupStyle() {
      if (this.options_layout === 'auto') {
        return {};
      } else {
        return {
          display: 'grid',
          'grid-template-columns': `repeat(auto-fill, ${this.options_layout === 'grid' ? '50%' : '100%'})`,
          margin: '4px 2px',
        };
      }
    },
  },
};
</script>

<style lang="scss">
.fs-field_label {
  margin-bottom: 12px;
  font-weight: 500;
  font-size: 13px;
  opacity: 0.8;
  color: #495057;
}
</style>
